
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Cheapestcabserviceinpune() {



    const cardData =
    {
        keyword: 'Cheapest Cab Service in Pune',
        heading: 'Morya Cabs: Cheapest Cab Service in Pune',
        headingDescription: 'Searching for the cheapest cab service in Pune without compromising on quality? Morya Cabs offers affordable travel solutions for local rides, airport transfers, and outstation trips. Our competitive pricing, well-maintained fleet, and professional drivers ensure a safe, comfortable, and economical travel experience every time. With transparent fares, 24/7 availability, and easy online cab booking, Morya Cabs has become the preferred choice for those looking for low-cost cab services in Pune. Whether you are commuting daily or planning a long journey, we provide dependable and pocket-friendly transportation tailored to your needs. Book the cheapest cab in Pune today and experience top-notch service at unbeatable rates with Morya Cabs.',

        top: 'Top Places to Visit in Pune with Morya Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Built in 1732, Shaniwar Wada was the seat of the Peshwas and remains Pune’s most iconic historical landmark. Though partially destroyed by fire, the grand Delhi Gate, majestic ruins, gardens, and evening light-and-sound shows transport visitors back to Maratha glory."
    },
    {
        "title": "Aga Khan Palace",
        "description": "This graceful monument was built in 1892 and played a crucial role during the Indian freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were interned here. The palace grounds are peaceful, and the museum preserves rare photographs, letters, and Gandhi’s personal belongings."
    },
    {
        "title": "Sinhagad Fort",
        "description": "About 30 km from Pune, Sinhagad Fort offers a perfect mix of history and adventure. Famous for Tanaji Malusare's valor during the Battle of Sinhagad, it’s a popular trekking spot with sweeping views, rustic food stalls, and cool breezes—especially captivating during monsoon."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most revered Ganpati temples in Maharashtra, Dagdusheth Temple is known for its magnificent idol adorned with gold and intricate decor. It's always bustling with devotees and is especially vibrant during Ganesh Chaturthi."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Its tranquil surroundings and monolithic Nandi mandapa make it a rare spiritual and archaeological gem in the city."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This fascinating museum houses over 20,000 objects including musical instruments, artifacts, paintings, and everyday items used by Indians over centuries. It gives a deep insight into India’s rich cultural and artistic heritage, all curated by one passionate collector."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "A 103-step climb leads to Parvati Hill, where you’ll find a 17th-century temple complex and panoramic views of Pune. Originally built during the Peshwa era, it is a peaceful spot for meditation, history, and photography."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Just 20 km from the city, this popular picnic spot is known for its tranquil lake views and local snacks along the roadside. It's a favorite weekend hangout for Pune residents, especially during sunset or monsoon drives."
    },
    {
        "title": "Osho Garden & Meditation Resort",
        "description": "Located in Koregaon Park, this lush retreat offers a blend of Zen-inspired architecture, serene gardens, and daily meditation programs. The Osho International Meditation Resort attracts global visitors for its unique spiritual and wellness atmosphere."
    },
    {
        "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
        "description": "Modeled after Japan’s Okayama Korakuen Garden, this sprawling 10-acre oasis is known for its manicured lawns, waterfalls, and serene walking paths. Ideal for peaceful family visits, morning walks, and nature photography within the city."
    }
],

  "services": [
    {
      "name": "Cheapest Cab Service in Pune",
      "description": "Morya Cab offers the cheapest cab service in Pune, providing budget-friendly rides without compromising on safety or comfort. Our affordable pricing ensures you get the best value for your travel needs."
    },
    {
      "name": "Low Fare Taxi Pune",
      "description": "Travel around Pune with low fare taxis from Morya Cab. We maintain transparent pricing with no hidden fees, making your daily commute or leisure travel pocket-friendly and hassle-free."
    },
    {
      "name": "Affordable Cab Hire Pune",
      "description": "Looking for affordable cab hire in Pune? Morya Cab provides economical taxi services with well-maintained vehicles and verified drivers to ensure a reliable and safe journey."
    },
    {
      "name": "Budget Cab Service Pune",
      "description": "Choose Morya Cab’s budget cab service in Pune for cost-effective travel options. Whether you need a quick ride or a longer trip, our budget services cater to all your transportation needs."
    },
    {
      "name": "Pocket-Friendly Pune Cab Booking",
      "description": "Book pocket-friendly cabs in Pune online with Morya Cab. We offer affordable rates for all trips, making it easier for you to travel without worrying about high costs."
    },
    {
      "name": "Verified Cheap Taxi in Pune",
      "description": "All cheap taxis offered by Morya Cab in Pune are verified for safety and reliability. Enjoy peace of mind with our trusted drivers and well-maintained vehicles at affordable prices."
    },
    {
      "name": "Local Travel Cheapest Cabs Pune",
      "description": "For your local travel needs in Pune, choose Morya Cab’s cheapest cabs that offer great service at low costs. Perfect for daily commutes, errands, and city tours."
    },
    {
      "name": "Best Rate Cab Pune City",
      "description": "Morya Cab provides the best rate cabs in Pune city, ensuring competitive pricing combined with excellent service quality and customer satisfaction."
    },
    {
      "name": "Online Lowest Fare Cab Pune",
      "description": "Book the lowest fare cabs online in Pune through Morya Cab’s easy booking platform. Enjoy convenience, transparency, and affordability all in one place."
    },
    {
      "name": "Quick and Cheap Taxi Booking Pune",
      "description": "Get quick and cheap taxi bookings in Pune with Morya Cab. Our responsive service ensures you find affordable rides fast, without sacrificing comfort or safety."
    },
    {
      "name": "Sedan SUV Cab in Budget Pune",
      "description": "Choose from budget-friendly sedan and SUV cabs in Pune with Morya Cab. Whether traveling solo or with family, we have vehicles to suit your budget and group size."
    },
    {
      "name": "Safe & Reliable Cheapest Pune Cabs",
      "description": "Morya Cab ensures that our cheapest cabs in Pune are both safe and reliable, driven by verified professionals who prioritize your comfort and security."
    },
    {
      "name": "City Rides at Lowest Price Pune",
      "description": "Enjoy city rides at the lowest price in Pune with Morya Cab. Ideal for quick trips, office commutes, and shopping errands without breaking the bank."
    },
    {
      "name": "Pune to Outstation Cheap Cabs",
      "description": "Planning an outstation trip? Morya Cab offers cheap and affordable outstation cabs from Pune, providing comfortable long-distance travel at economical rates."
    },
    {
      "name": "Cheapest Daily Commute Taxi Pune",
      "description": "For your daily commute in Pune, choose Morya Cab’s cheapest taxi services. Reliable, punctual, and affordable rides that fit your everyday travel needs."
    }
  ],
  "tableData": [
    ["Cheapest Cab Service in Pune", "-Low Fare Taxi Pune"],
    ["Affordable Cab Hire Pune", "-Budget Cab Service Pune"],
    ["Pocket-Friendly Pune Cab Booking", "-Verified Cheap Taxi in Pune"],
    ["Local Travel Cheapest Cabs Pune", "-Best Rate Cab Pune City"],
    ["Online Lowest Fare Cab Pune", "-Quick and Cheap Taxi Booking Pune"],
    ["Sedan SUV Cab in Budget Pune", "-Safe & Reliable Cheapest Pune Cabs"],
    ["City Rides at Lowest Price Pune", "-Pune to Outstation Cheap Cabs"],
    ["Cheapest Daily Commute Taxi Pune", "-Call Morya Cab at +91 9371304510"]
  ],




whychoose: [
    {
        "WhyChooseheading": "Lowest Fare Guarantee in Pune",
        "WhyChoosedescription": "Morya Cab is committed to offering the most affordable cab service in Pune without compromising on quality. Whether it's a quick local ride, office commute, or daily travel, our fare structure is designed to be the lowest in the city. We beat the surge pricing and deliver rides that are light on your wallet and high on value."
    },
    {
        "WhyChooseheading": "No Hidden Charges – 100% Transparent Pricing",
        "WhyChoosedescription": "With Morya Cab, you get a fully transparent billing experience. The price you see is the price you pay—no hidden costs, no extra charges during peak hours, and no last-minute surprises. Our fare includes fuel, driver charges, and taxes so you can travel with total peace of mind."
    },
    {
        "WhyChooseheading": "Economical Vehicles for Daily Travel",
        "WhyChoosedescription": "Our budget-friendly fleet includes compact hatchbacks and fuel-efficient sedans—ideal for solo riders, students, daily commuters, and seniors looking for a safe yet economical ride. These cars are perfect for short distances within Pune while still offering air conditioning, clean interiors, and a comfortable experience."
    },
    {
        "WhyChooseheading": "Discounts, Offers, and Wallet Cashback",
        "WhyChoosedescription": "We regularly offer special deals, first-ride discounts, referral bonuses, and wallet cashbacks to make your rides even cheaper. Follow us online or subscribe to our notifications to stay updated with the latest promo codes and limited-time offers that help you save even more."
    },
    {
        "WhyChooseheading": "Flexible Booking with Multiple Payment Options",
        "WhyChoosedescription": "Book easily via our app, website, or helpline. We support all popular payment methods including UPI, digital wallets, debit/credit cards, and cash. Our system is quick, simple, and designed to give you the cheapest cab ride in Pune with zero booking hassle."
    },
    {
        "WhyChooseheading": "Reliable Service at an Affordable Price",
        "WhyChoosedescription": "Low cost doesn't mean low quality. Our drivers are polite, punctual, and trained for local routes. Even in our most affordable category, we ensure safety, reliability, and courteous service—making Morya Cab the perfect choice for both everyday travel and budget-conscious customers."
    },
    {
        "WhyChooseheading": "Ideal for Students, Working Professionals, and Daily Riders",
        "WhyChoosedescription": "If you're a college student, office-goer, or someone who travels frequently within Pune, our cheapest cab service is tailored for you. Enjoy economical rates for repeat bookings and long-term savings on your everyday commute with Morya Cab."
    },
    {
        "WhyChooseheading": "24/7 Low-Cost Cab Availability",
        "WhyChoosedescription": "Even at night or during early morning hours, Morya Cab offers affordable rides without inflated pricing. We operate 24/7, so whether you need to catch a train, go to the airport, or return from a late shift, you’ll always find the cheapest cab ready to go."
    }
]





















    }

const faqData = [
  {
    question: "How can I book the cheapest cab service in Pune with Morya Cab?",
    answer: "Simply visit our website, use the Morya Cab app, or call our customer care to book budget-friendly cab rides instantly."
  },
  {
    question: "What makes Morya Cab the most affordable cab service in Pune?",
    answer: "We offer competitive pricing, optimized routes, and cost-efficient vehicle options to deliver reliable cab service at the lowest possible rates."
  },
  {
    question: "Are there any hidden charges or extra fees?",
    answer: "No hidden charges! Our pricing is 100% transparent. You see the fare upfront before confirming your ride."
  },
  {
    question: "Which areas in Pune do you cover with your cheapest cab service?",
    answer: "We cover the entire Pune city including Hinjewadi, Wakad, Baner, Hadapsar, Kothrud, Kharadi, and more—at budget-friendly rates."
  },
  {
    question: "What types of vehicles are available under the cheapest cab category?",
    answer: "Our budget cab fleet includes hatchbacks and entry-level sedans—perfect for short city trips and daily commutes at low cost."
  },
  {
    question: "Do you offer discounts or coupons for frequent users?",
    answer: "Yes, we offer regular discounts, referral bonuses, and wallet cashback offers through our app and website. Stay tuned for deals!"
  },
  {
    question: "Can I use the cheapest cab service for airport or outstation travel?",
    answer: "Yes, affordable pricing is available for airport transfers and selected outstation routes as well. You can even pre-book for lower fares."
  },
  {
    question: "What payment options are accepted for low-cost cab bookings?",
    answer: "We accept UPI, credit/debit cards, net banking, and cash payments. Online pre-payment is also available."
  },
  {
    question: "Is the quality of service good despite the low fare?",
    answer: "Yes, we maintain clean vehicles and professional drivers, ensuring safety and comfort even in our lowest-priced rides."
  },
  {
    question: "Why choose Morya Cab for the cheapest cab service in Pune?",
    answer: "Morya Cab offers unbeatable prices without compromising service quality—making us the best choice for economical and dependable travel in Pune."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Nilesh Pawar',
    role: 'Budget Traveler',
    review: 'Morya Cab is truly the cheapest cab service I’ve used in Pune. Clean cars, polite drivers, and no hidden costs. Highly affordable!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Prachi K.',
    role: 'College Student',
    review: 'I needed a low-cost ride to college every day, and Morya Cab was the best option. Reliable and pocket-friendly!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];












      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
   
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Pune",
  "image": "https://moryacab.com/assets/images/cheapest-cab-service-in-pune.jpg",
  "description": "Morya Cab offers the cheapest cab service in Pune with affordable fares and reliable travel options. Choose from AC Sedan, SUV, Innova Crysta, and Tempo Traveller for city rides, airport transfers, outstation trips, and corporate travel. Clean vehicles, verified drivers, and transparent pricing for budget-friendly travel.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "10,412"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/cheapest-cab-service-in-pune"
  }
};








    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Cheapest Cab Service in Pune | Budget Taxi & Car Rental – Morya Cab</title>
  <meta
    name="description"
    content="Book the cheapest cab service in Pune with Morya Cab. Affordable taxi booking for city rides, airport transfers & outstation trips. Choose Sedan, SUV, Innova Crysta & Tempo Traveller at budget-friendly fares."
  />
  <meta
    name="keywords"
    content="Cheapest cab service in Pune, Low cost cab Pune, Budget taxi service Pune, Affordable cab Pune, Cheap taxi booking Pune, Cheapest airport cab Pune, Cheapest outstation cab Pune, Pune city budget cab, Morya Cab Pune cheapest service"
  />
  <link rel="canonical" href="https://moryacab.com/cheapest-cab-service-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Cheapest Cab Service in Pune | Budget Taxi & Car Rental – Morya Cab" />
  <meta property="og:description" content="Hire the cheapest cab service in Pune with Morya Cab. Affordable fares, verified drivers & clean vehicles for city, outstation & airport travel." />
  <meta property="og:url" content="https://moryacab.com/cheapest-cab-service-in-pune" />
  <meta property="og:image" content="https://moryacab.com/assets/images/cheapest-cab-service-in-pune.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/112.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Cheapestcabserviceinpune;